import React, { useEffect, useState, } from "react";
import { useTranslation } from "react-i18next";

import Base from '../utils/base'

export default function MobileNav(props) {
	var base = new Base()
	const {t, i18n} = useTranslation()

	const [phone, setPhone] = useState('')
	const [email, setEmail] = useState('')
	const [address, setAddress] = useState('')
	const [facebook, setFacebook] = useState('')
	const [tiktok, setTiktok] = useState('')
	const [instagram, setInstagram] = useState('')
	const [wa, setWa] = useState('')

	function onCloseClicked(){
		window.$(".mobile-nav__wrapper").removeClass("expanded");
	}

	useEffect(() => {
		var lang = window.localStorage.getItem('lang')
		i18n.changeLanguage(lang != null ? lang : 'en')

		get_info_data()
	}, [])
		
	async function get_info_data() {
		var response = await base.request(base.url_api + "/setting")

		if(response != null){
			if(response.status == "success"){
				for(let data of response.data){
					if(data.key == 'phone')
						setPhone(data.value)
					else if(data.key == 'address')
						setAddress(data.value)
					else if(data.key == 'email')
						setEmail(data.value)
					else if(data.key == 'facebook')
						setFacebook(data.value)
					else if(data.key == 'tiktok')
						setTiktok(data.value)
					else if(data.key == 'instagram')
						setInstagram(data.value)
					else if(data.key == 'wa_link')
						setWa(data.value)
				}
				
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

	return (
		<>
			<div className="mobile-nav__wrapper">
				<div className="mobile-nav__overlay mobile-nav__toggler" onClick={() => onCloseClicked()}></div>
				<div className="mobile-nav__content">
					<span className="mobile-nav__close mobile-nav__toggler" onClick={() => onCloseClicked()}><i className="fa fa-times"></i></span>
					<div className="logo-box">
						<a href="/" aria-label="logo image">
							<img src="img/Mooz_Logo.png" width="130" alt=" solinom logo" />
						</a>
					</div>
					<div className="mobile-nav__container"></div>
					<ul className="mobile-nav__contact list-unstyled">
						<li>
							<i className="fa fa-envelope"></i>
							<a target="_blank" href={"mailto:" + email} style={{ fontSize: '1rem', }}>{email}</a>
						</li>

						<li>
							<i className="fa fa-phone-alt"></i>
							<a target="_blank" href={"tel:" + phone} style={{ fontSize: '1rem', }}>{phone}</a>
						</li>
					</ul>
					<div className="mobile-nav__social">
						<a target="_blank" href={facebook}> <i class="fa-brands fa-facebook"></i> <span className="sr-only">Facebook</span></a>
						<a target="_blank" href={wa}> <i class="fa-brands fa-whatsapp"></i> <span className="sr-only">Twitter</span></a>
						<a target="_blank" href={instagram}> <i class="fa-brands fa-instagram"></i> <span className="sr-only">youtube</span></a>
						<a target="_blank" href={tiktok}> <i class="fa-brands fa-tiktok"></i> <span className="sr-only">Tiktok</span></a>
					</div>
				</div>
			</div>

			<div className="search-popup">
				<div className="search-popup__overlay search-toggler"></div>
				<div className="search-popup__content">
					<form role="search" method="get" className="search-popup__form" action="#">
						<input type="text" id="search" placeholder="Search Here..." />
						<button type="submit" aria-label="search submit" className="solinom-btn solinom-btn--base">
							<span><i className="icon-search"></i></span>
						</button>
					</form>
				</div>
			</div>
		</>
	);
};
